module.exports = __webpack_public_path__ + "img/Picture 5.aeb78bfa.png";